import { BaseDto } from './base.dto'

export class ShippingProviderDataDto {
  providerId: string
  providerName: string
  enabled: boolean
}

export enum ShippingProvider {
  Nham24 = 'Nham24',
  CambodianExpress = 'Cambodian Express'
}

export class ShippingZoneDto extends BaseDto {
  city: string
  enabled: boolean
  geometry: any
  provinceCode: string
  cost: number
  defaultGeometry: any
  provider: ShippingProviderDataDto[]
  rates: ShippingRateDto[]
  lat: number
  lng: number
}

export class ShippingProviderDto extends BaseDto {
  name: string
  sortOrder: number

  static create() {
    return new ShippingProviderDto()
  }
}

export class UpdateShippingProviderDto {
  name?: string
  nameKh?: string
}

export class ShippingRateDto extends BaseDto {
  public min: number
  public providerCost: number
  public customerCost: number
  public shippingZoneId: string
  public shippingProviderId: string
  public zone: ShippingZoneDto
  public provider: ShippingProviderDto
  public enabled: boolean

  static create() {
    return new ShippingRateDto()
  }
}

export class UpdateShippingZoneDto {
  geometry?: any
  cost?: number
}

export class UpdateShippingRateDto {
  enabled?: boolean
  minDays?: number
  maxDays?: number
  providerCost?: number
  customerCost?: number
}